import React from 'react';

export default function DefaultOptionMessage() {
  return (
    <p className="mb-3">
      When an option name is listed as "Buildout Default", Buildout dynamically chooses which option
      to default to based on property or broker information. You can override this, but then you
      will lose the power of dynamic switching to best suit the content.
    </p>
  );
}
